export default "__VITE_ASSET__Dd6r2jo0__"